import MobileMenu from './MobileMenu';
import DesktopNavigation from './DesktopNavigation';

const NavBar = () => {
  return (
    <div>
      <div className="lg:hidden">
        <MobileMenu />
      </div>

      <div className="hidden lg:flex">
        <DesktopNavigation />
      </div>
    </div>
  );
};

export default NavBar;
